import React from 'react';

import './BottomSection.scss';

import {Button} from "rsuite";

const BottomSection = (props) => {
    const {handleNext} =props;

    return (
        <div className="bottom-section">
            <div className={`button-container`}>
                <Button appearance={'primary'}
                        loading={false}
                        onClick={handleNext}
                        className={`text-small button-primary`}
                        block>
                    دریافت رژیم
                </Button>
            </div>
        </div>
    );
}

export default BottomSection;